import { fetchOptions } from "Services/util/fetchInterceptorState";

/**
 * We wrap the fetch function to intercept and handle any HTTP response. The app should always use this Ponyfill instead of the window's fetch.
 * @param args regular fetch arguments
 * @returns exact same fetch API, but the configured fetch callback will be executed before the promise is returned
 */
export const fetch: typeof window.fetch = (...args) =>
    fetchOptions.interceptEnabled ? window.fetch(...args).then(fetchOptions.onFetchCallback) : window.fetch(...args);
